/* eslint-disable react/jsx-props-no-spreading */

import React from 'react';
import styled from 'styled-components';
import Svg from '_assets/svg';

const Img = styled.img`
    width: 16px;
    height: 16px;
`;

const Button = styled.button`
    width: 16px;
    height: 16px;
    background: transparent;
    border: 0px;
    &:focus {
        outline: none;
    }
    ${props => props.loading && `
        -webkit-animation: rotation 0.5s infinite linear;
        animation: rotation 0.5s infinite linear;
    `}
  `;


const RefreshButton = (props) => {
    const { className, onClick, loading } = props;
    return (
        <Button loading={loading} onClick={onClick} className={`d-flex align-items-center justify-content-center ${className}`}>
            <Img src={Svg.refresh.default} />
        </Button>
    )
}

export default RefreshButton;